/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilestoreAttachmentRequest } from './FilestoreAttachmentRequest';
import {
    FilestoreAttachmentRequestFromJSON,
    FilestoreAttachmentRequestFromJSONTyped,
    FilestoreAttachmentRequestToJSON,
} from './FilestoreAttachmentRequest';

/**
 * 
 * @export
 * @interface AttachToClusterRequest
 */
export interface AttachToClusterRequest {
    /**
     * 
     * @type {number}
     * @memberof AttachToClusterRequest
     */
    clusterId: number;
    /**
     * 
     * @type {Array<FilestoreAttachmentRequest>}
     * @memberof AttachToClusterRequest
     */
    attachments: Array<FilestoreAttachmentRequest>;
}

/**
 * Check if a given object implements the AttachToClusterRequest interface.
 */
export function instanceOfAttachToClusterRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clusterId" in value;
    isInstance = isInstance && "attachments" in value;

    return isInstance;
}

export function AttachToClusterRequestFromJSON(json: any): AttachToClusterRequest {
    return AttachToClusterRequestFromJSONTyped(json, false);
}

export function AttachToClusterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachToClusterRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clusterId': json['cluster_id'],
        'attachments': ((json['attachments'] as Array<any>).map(FilestoreAttachmentRequestFromJSON)),
    };
}

export function AttachToClusterRequestToJSON(value?: AttachToClusterRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cluster_id': value.clusterId,
        'attachments': ((value.attachments as Array<any>).map(FilestoreAttachmentRequestToJSON)),
    };
}

